export default "__VITE_ASSET__CczU$ps5__"